import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import {
  loadMaterial,
  saveMaterial,
  saveMaterialAsDraft,
} from 'store/slices/materials/actions';
import { IMaterial, TMaterialDraft } from 'store/slices/materials/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import { StatusesEnum } from 'constants/status';

import { MaterialForm } from './components/MaterialForm';
import { mapValuesToForm } from './components/formUtils';

export const Edit = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.materials);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadMaterial(id));
  }, []);

  const onFinish = (values: IMaterial) => {
    setIsLoading(true);
    dispatch(saveMaterial({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/materials');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: TMaterialDraft) => {
    setIsLoading(true);
    dispatch(saveMaterialAsDraft({ ...values, id: item.id }))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Сущность успешно изменена',
        });
        navigate('/materials');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/materials');
  };

  return (
    <MainLayout pageTitle='Редактирование'>
      {item.id && item.id === id ? (
        <MaterialForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft={item.status === StatusesEnum.DRAFT}
          isLoading={isLoading}
          initialValues={mapValuesToForm(item)}
        />
      ) : null}
    </MainLayout>
  );
};
